// src/public/icons/TruckIcon.jsx
import React from 'react';

const TruckIcon = ({ 
  size = 24, 
  color = "#55000C", 
  strokeWidth = 1.5, 
  className = "", 
  ...props 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M9.00781 17C9.00781 17.5304 8.7971 18.0391 8.42203 18.4142C8.04695 18.7893 7.53825 19 7.00781 19C6.47738 19 5.96867 18.7893 5.5936 18.4142C5.21853 18.0391 5.00781 17.5304 5.00781 17C5.00781 16.4696 5.21853 15.9609 5.5936 15.5858C5.96867 15.2107 6.47738 15 7.00781 15C7.53825 15 8.04695 15.2107 8.42203 15.5858C8.7971 15.9609 9.00781 16.4696 9.00781 17ZM19.0078 17C19.0078 17.5304 18.7971 18.0391 18.422 18.4142C18.047 18.7893 17.5382 19 17.0078 19C16.4774 19 15.9687 18.7893 15.5936 18.4142C15.2185 18.0391 15.0078 17.5304 15.0078 17C15.0078 16.4696 15.2185 15.9609 15.5936 15.5858C15.9687 15.2107 16.4774 15 17.0078 15C17.5382 15 18.047 15.2107 18.422 15.5858C18.7971 15.9609 19.0078 16.4696 19.0078 17Z" 
      stroke={color} 
      strokeWidth={strokeWidth}
    />
    <path 
      d="M2.00781 10H18.0078M2.00781 10C2.00781 10.78 1.98781 13.04 2.01181 15.26C2.04781 15.98 2.16781 16.58 5.00981 17M2.00781 10C2.22381 8.26 3.16281 6.2 3.64281 5.42M9.00781 10V5M14.9978 17H9.00281M2.02381 5H12.2408C12.2408 5 12.7808 5 13.2608 5.048C14.1598 5.132 14.9148 5.54 15.6708 6.56C16.4708 7.64 17.0858 9.008 17.9008 9.74C19.2558 10.956 21.8338 10.58 21.9778 13.16C22.0138 14.48 22.0138 15.92 21.9538 16.16C21.8578 16.867 21.3128 16.982 20.6348 17C20.0468 17.016 19.3378 16.972 18.9918 17" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round"
    />
  </svg>
);

export default TruckIcon;